import { createFileRoute } from '@tanstack/react-router'
import { TestAIChat } from '../../../../components/TestAIChat'

export const Route = createFileRoute('/platform/desa/$desaId/test-ai')({
  component: () => {
    const { desaId } = Route.useParams()
    return <TestAIChat desaId={desaId} />
  },
})
